<template>
  <div style="width: 400px;">
    <el-form ref="loginForm" size="mini" :model="form" :rules="rules" label-width="80px" class="login-box">
      <h3 class="login-title">密码修改</h3>
      <el-form-item label="原始密码" prop="oldpwd">
        <el-input type="password" placeholder="请输入原始密码" v-model="form.oldpwd"></el-input>
      </el-form-item>
      <el-form-item label="新 密 码" prop="password">
        <el-input type="password" placeholder="请输入新密码" minlength="6" v-model="form.password"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="spassword">
        <el-input type="password" placeholder="请重复新密码" minlength="6" v-model="form.spassword"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" v-on:click="f_Submit()">确认</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>

  import * as Api from '../api/api';

  export default {
    data() {
      return {
        form: {
          oldpwd: "",
          password: "",
          spassword: ""
        },
        user: JSON.parse(sessionStorage.getItem("user")),
        rules: {
          oldpwd: [
            {required: true, message: '原始密码不能为空', trigger: 'blur'}
          ],
          password: [
            {required: true, message: '新密码不可为空', trigger: 'blur'},
            {min: 6, max: 8, message: '长度在 6 到 8 个字符', trigger: 'blur'}
          ],
          spassword: [
            {required: true, message: '重复密码不可为空', trigger: 'blur'},
            {min: 6, max: 8, message: '长度在 6 到 8 个字符', trigger: 'blur'}
          ]
        }
      }
    },
    mounted() {

    },
    methods: {
      f_Submit() {
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            if (this.form.spassword !== this.form.password) {
              this.$message.warning("新密码与重复密码不一致，请重新输入!");
              return;
            }
            let parm = {
              id: this.user.id,
              oldpwd: this.form.oldpwd,
              newpwd: this.form.spassword
            };
            let that=this;
            Api.ChangePwd(parm).then(res => {
              if (res.code === 1) {
                this.$alert("修改成功，重新登录", "提示信息", {
                  type:'success',
                  callback() {
                    that.$router.replace("/login");
                  }
                });
              } else {
                this.$message.error(`修改失败:${res.error}`);
              }
            });
          }
        });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ModiPwd.vue